import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { Team } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service login and authenticate a team for registration
 */
@Injectable()
export class TeamUserService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Login a team
     */
    public login(eventId: string, teamId: string, password: string): Observable<Team> {
        const apiRequestUrl: string = `${this.getApiUrl(eventId, teamId)}/login`;

        const data: any = { data: { attributes: { password: password } } };

        return this.http.post<Team>(apiRequestUrl, JSON.stringify(data))
            .pipe(map((response: Team) => response));
    }

    /**
     * Check if the user is authenticated to register the team
     */
    public isAuthenticated(eventId: string, teamId: string): Observable<boolean> {
        const apiRequestUrl: string = `${this.getApiUrl(eventId, teamId)}/is-authenticated`;

        return this.http.get<boolean>(apiRequestUrl).pipe(map((response: boolean) => response));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(eventId: string, teamId: string): string {
        const url: string = `${this.http.configService.getApiBaseUrl()}/events/${eventId}/teams/${teamId}/users`;
        return url;
    }
}
